/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { Box, Theme, makeStyles, Typography } from '@material-ui/core';
import VideocamIcon from '@material-ui/icons/Videocam';
import PermMediaIcon from '@material-ui/icons/PermMedia';
import LinkIcon from '@material-ui/icons/Link';
import ImageIcon from '@material-ui/icons/Image';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import { Orientation, Shape } from '../types/types';
import AddButton from './AddButton';

interface PlaceholderStyleProps {
  orientation: Orientation,
  shape: Shape,
  clickable: boolean,
  iconOffset: number
}

const useStyles = makeStyles<Theme, PlaceholderStyleProps>((theme: Theme) => ({
  container: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: (props) => (props.orientation === Orientation.Horizontal ? 'row' : 'column'),
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0',
    padding: '0',
    backgroundColor: '#EDF3F5',
    position: 'relative',
    overflow: 'visible',
    borderRadius: (props) => (props.shape === Shape.Round ? '50%' : 'none')
  },
  text: {
    fontFamily: 'Prompt, sans-serif',
    fontSize: '18px',
    fontStyle: 'normal',
    fontWeight: 400,
    letterSpacing: '0em',
    textAlign: 'left',
    color: '#9896A7',
    marginTop: (props) => (props.orientation === Orientation.Vertical ? '15px' : '0px'),
    marginLeft: (props) => (props.orientation === Orientation.Horizontal ? '17px' : '0px')
  },
  addWrapperRound: {
    position: 'absolute',
    right: (props) => (`${props.iconOffset}%`),
    top: (props) => (`${props.iconOffset}%`),
    zIndex: 1,
    backgroundColor: '#fff',
    borderRadius: '50%',
    boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.25)',
    display: (props) => (props.clickable ? 'inline' : 'none'),
    opacity: (props) => (props.clickable ? 1 : 0),
    clickEvents: (props) => (props.clickable ? 'auto' : 'none')
  },
  addWrapperRect: {
    position: 'absolute',
    right: '-18px',
    top: '-18px',
    zIndex: 1,
    backgroundColor: '#fff',
    borderRadius: '50%',
    boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.25)',
    display: (props) => (props.clickable ? 'inline' : 'none'),
    opacity: (props) => (props.clickable ? 1 : 0),
    clickEvents: (props) => (props.clickable ? 'auto' : 'none')
  }
}));


export enum PlaceholderType {
  Video = 'video',
  Image = 'image',
  Link = 'link',
  Files = 'files',
  Avatar = 'avatar'
}

interface PlaceholderProps {
  onClick?: (event: React.MouseEvent<HTMLElement, MouseEvent>) => void,
  type: PlaceholderType,
  text?: string,
  orientation?:Orientation
  shape?:Shape,
  iconOffsetPercent?: number
  pad?: string
}

const Placeholder: React.FC<PlaceholderProps> = ({
  type,
  onClick,
  text = null,
  orientation = Orientation.Vertical,
  shape = Shape.Rect,
  iconOffsetPercent = 5,
  pad
}) => {
  const getIcon = () => {
    switch (type) {
      case PlaceholderType.Video:
        return <VideocamIcon style={{ fill: '#9896A7' }} />;
      case PlaceholderType.Image:
        return <ImageIcon style={{ fill: '#9896A7' }} />;
      case PlaceholderType.Link:
        return <LinkIcon style={{ fill: '#9896A7' }} />;
      case PlaceholderType.Avatar:
        return <AccountBoxIcon style={{ fill: '#9896A7' }} />;
      default:
        return <PermMediaIcon style={{ fill: '#9896A7' }} />;
    }
  };

  const clickable = !(!onClick);
  const styles = useStyles({ orientation, shape, clickable, iconOffset: iconOffsetPercent });

  return (
    <div className={styles.container} onClick={onClick} id='placeholder' style={{ padding: pad }}>
      { getIcon() }
      {
        text
          ? <Typography className={styles.text}>{text}</Typography>
          : null
      }
      <Box className={shape === Shape.Rect ? styles.addWrapperRect : styles.addWrapperRound}>
        <AddButton />
      </Box>
    </div>
  );
};

export default Placeholder;
